import * as yup from "yup";

export const updateAddressSchema = yup.object().shape({
  address: yup.string().required("Address is required"),
  pin: yup
    .string()
    .required("Pin Code is required")
    .test("len", "Pin Code must be 6 digit", (val) => val?.length === 6),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  area: yup.string().required("Area is required"),
  locality: yup.string().required("Locality is required"),
  // lat: yup.string().required("Latitude is required"),
  // long: yup.string().required("Longitude is required"),
});

export const updateAddressContactDetailsSchema = yup.object().shape({
  address: yup.string().required("Address is required"),
  pin: yup
    .string()
    .required("Pin Code is required")
    .test("len", "Pin Code must be 6 digit", (val) => val?.length === 6),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  contact_no1: yup
    .string()
    .trim()
    .min(10, "Phone number must be at least 10 digits")
    .required("Phone number is required")
    .matches(/^[6-9]\d{9}$/, "Invalid phone number"),
  contact_no2: yup
    .string()
    .trim()
    .min(10, "Phone number must be at least 10 digits")
    .matches(/^[6-9]\d{9}$/, "Invalid phone number"),
  email_ids: yup
    .array()
    .of(yup.string().email("Invalid email").required("Email is required"))
    .min(1, "At least one email is required"),
  // lat: yup.string().required("Latitude is required"),
  // long: yup.string().required("Longitude is required"),
});

export const updateGstSchema = yup.object().shape({
  gst_no: yup
    .string()
    .min(15, "GST number should be of 15 digit")
    .required("GSTIN number is required"),
  company: yup.string().required("GST Name is required"),
});

export const updateBusinessPanSchemaBorrower = yup.object().shape({
  business_pan_no: yup
    .string()
    .trim()
    .length(10, "PAN number must be 10 characters")
    .required("PAN number is required")
    .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, "Invalid PAN number"),
});

export const updateCreditDetailsSchema = yup.object().shape({
  nbfc_partner: yup.string().required("NBFC partner is required"),
  emi_repayment_mode: yup.string().required("EMI repayment mode is required"),
  credit_limit: yup
    .number()
    .typeError("Credit limit must be a number")
    .positive("Credit limit must be greater than 0")
    .required("Credit limit is required"),
  interest_rate: yup
    .number()
    .typeError("Enter valid interest rate")
    .min(0, "Cannot be negative")
    .max(100, "Cannot exceed 100%")
    .required("Interest rate is required"),
  processing_fee: yup
    .number()
    .typeError("Enter valid processing fee percentage")
    .min(0, "Processing fee cannot be negative")
    .max(100, "Processing fee cannot exceed 100%")
    .required("Processing fee is required"),
  late_fee: yup
    .number()
    .typeError("Late fee must be a number")
    .min(0, "Late fee cannot be negative")
    .max(100, "Late fee cannot exceed 100%")
    .required("Late fee is required"),
  disbursement_type: yup.string().required("Disbursement type is required"),
});

export const updateGstSchemaBorrower = yup.object().shape({
  gst_no: yup
    .string()
    .min(15, "GST number should be of 15 digit")
    .required("GSTIN number is required"),
  name: yup.string().required("GST Name is required"),
});

export const updateBusinessDetailsSchema = yup.object().shape({
  business_type: yup.string().required("Business type is required"),

  fssai_no: yup
    .string()
    .trim()
    .matches(/^\d{14}$/, "FSSAI number must be 14 digits")
    .required("FSSAI number is required"),

  tin_no: yup
    .string()
    .trim()
    .min(8, "TIN number must be at least 8 characters")
    .max(15, "TIN number cannot exceed 15 characters")
    .required("TIN number is required"),

  cin_no: yup
    .string()
    .trim()
    .matches(
      /^[LU]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/,
      "Invalid CIN number format",
    )
    .required("CIN number is required"),

  uin_no: yup
    .string()
    .trim()
    .min(6, "UIN number must be at least 6 characters")
    .max(20, "UIN number cannot exceed 20 characters")
    .required("UIN number is required"),

  dl_no: yup
    .string()
    .trim()
    .min(6, "DL number must be at least 6 characters")
    .max(20, "DL number cannot exceed 20 characters")
    .required("DL number is required"),

  cst_no: yup
    .string()
    .trim()
    .min(6, "CST number must be at least 6 characters")
    .max(20, "CST number cannot exceed 20 characters")
    .required("CST number is required"),
});

export const ownerSchema = yup.object().shape({
  owner_name: yup.string().required("Owner name is required"),
  phone_number: yup
    .string()
    .matches(/^[6-9]\d{9}$/, "Invalid phone number")
    .required("Phone number is required"),
  aadhaar_no: yup
    .string()
    .length(12, "Aadhaar must be 12 digits")
    .required("Aadhaar number is required"),
  pan_no: yup
    .string()
    .length(10, "PAN must be 10 characters")
    .required("PAN number is required"),
});

export const createLocationSchema = yup.object().shape({
  provider_name: yup.string().required("Provider Name is required"),
  mobile_number: yup
    .number()
    .typeError("must be a number")
    .min(6000000000, "must be greater than or equal to 6000000000")
    .required("Mobile is required"),
  address: yup.string().required("Address is required"),
  landmark: yup.string().required("Landmark is required"),
  pin: yup
    .string()
    .required("Pin Code is required")
    .test("len", "Pin Code must be 6 digit", (val) => val?.length === 6),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  upi_id: yup.string().when("account_type", {
    is: (account_type: string) => account_type === "upi",
    then: yup.string().required("UPI ID is required"),
  }),
  upi_name: yup.string().when("account_type", {
    is: (account_type: string) => account_type === "upi",
    then: yup.string().required("UPI Name is required"),
  }),
  account_name: yup.string().when("account_type", {
    is: (account_type: string) => account_type === "bank_acc",
    then: yup.string().required("Account name is required"),
  }),
  account_no: yup.string().when("account_type", {
    is: (account_type: string) => account_type === "bank_acc",
    then: yup.string().required("Account no. is required"),
  }),
  bank_name: yup.string().when("account_type", {
    is: (account_type: string) => account_type === "bank_acc",
    then: yup.string().required("Bank name is required"),
  }),
  // branch_name: yup.string().when("account_type", {
  //   is: (account_type: string) => account_type === "bank_acc",
  //   then: yup.string().required("Branch name is required"),
  // }),
  ifsc_code: yup.string().when("account_type", {
    is: (account_type: string) => account_type === "bank_acc",
    then: yup
      .string()
      .min(11, "Please enter 11-digit IFSC code")
      .max(11, "Please enter 11-digit IFSC code")
      .required("IFSC Code is required"),
  }),
});
